import React, { useState, useEffect, useMemo, useRef } from 'react';
import {
  Container,
  FormGroup,
  Label,
  Input,
  Button,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  InputGroup, InputGroupAddon, InputGroupText
} from 'reactstrap';
import { connect } from 'react-redux';
import { IBienBloquer, IBienBloquerReduxProps, ITarget, IVente } from '../../types/interfaces';

import TableContainer from "../tables_manager/TableContainer"
import EditableCell from "../tables_manager/EditableCell";
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { deOrBloqueBien } from '../../flux/actions/bienActions';
import { getUsers } from '../../flux/actions/userActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash, faExternalLinkAlt, faPen, faSpinner, faCheckCircle, faLock, faLockOpen, faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
import axios from 'axios';
import { E_ERROR } from '../../types/errors';
import { useAlert } from "react-alert";
import moment from "moment";
import { getConstanteProjetInfos, getConstanteRecuImageIncrem } from '../../flux/actions/constanteActions';
import { instantUploadToFTP } from '../pdf/PDFLink';
import { constants } from '../../types/constants';
import DatePicker from "reactstrap-date-picker";
import ReactTooltip from 'react-tooltip';
import { PRIVILEGE } from '../../types/privileges';

const BienBloquer = ({
  modal,
  setModal,
  modalBloque,
  deOrBloqueBien,
  bloque,
  societeValue,
  getUsers,
  user,
  auth
 }: IBienBloquer) => {
  const { users, loading: loadingU } = user;
  const userOptions = users.map(e => ({value: e, label: e.username}));
  const [userValue, setUserValue] = useState<any>('');
  const [idValue, setIdValue] = useState(-1);
  const [designationValue, setDesignationValue] = useState('');
  const datesSuggestions = [{value: 2, label: "2 jours"}, {value: 7, label: "7 jours"}, {value: 10, label: "10 jours"}, {value: 14, label: "14 jours"}];
  const usersSuggestions = [{value: 19, label: "Chihab Hayat"}, {value: 28, label: "Zahid Redouan"}, {value: 24, label: "Bouziane Mohcine"}];
  const [deblockDate, setDeblockDate] = useState<any>('');
  const [commentValue, setCommentValue] = useState('');
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [reEnable, setReEnable] = useState(false);

  const alert = useAlert();
  
  const handleToggle = () => setModal(!modal);
  
  const deblockDateChangeHandler = (e, t) => {
    setDeblockDate(e);
  };
  const handleUserChange = data => {
    setUserValue(data ? data.value : '');
  };
  const commentChangeHandler = (e: ITarget) => setCommentValue(e.target.value);

  const modalOpenedHandle = () => {
    if(modalBloque && modalBloque !== ''){
      setIdValue(modalBloque["id"]);
      setDesignationValue(modalBloque["DESIGNATION"]);
      setDeblockDate(modalBloque?.bloque_until || '');
      setCommentValue('');
    }
  };

  const modalClosedHandle = () => {
    setIdValue(-1);
    setDesignationValue('');
    setDeblockDate('');
    setUserValue('')
    setCommentValue('');
    if(reEnable){
      setDisableSubmit(false);
      setReEnable(false);
    }
  };

  const callback = (success, errMsg, bloque) => {
    if(success){
      setReEnable(true);
      setModal(false);
      alert.success(`Bien ${bloque ? "bloqué" : "débloqué"} avec succès`);
      return
    }
    alert.error(errMsg || "Une erreur s'est produite");
    setDisableSubmit(false);
  }

  const deOrBloquerHandle = async () => {
    if(idValue === -1)
      return
    // const isDg = auth?.user?.speciality === constants.ROLE_DG ? 1 : 0;
    // const isDc = auth?.user?.speciality === constants.ROLE_DC ? 1 : 0;
    // if(isDg === 0 && isDc === 0){
    //   alert.error("Action non autorisée")
    //   return
    // }
    setDisableSubmit(true);
    deOrBloqueBien(idValue, bloque, deblockDate, userValue?.id, commentValue, auth?.user?.id, callback);
  };

  return (
    <div>
      <Modal isOpen={modal} toggle={handleToggle} onOpened={modalOpenedHandle} onClosed={modalClosedHandle}>
        <ModalHeader toggle={handleToggle}><FontAwesomeIcon icon={faPen} />&nbsp;&nbsp;Déblocage/Blocage des biens</ModalHeader>
        <ModalBody>
            <Container className="linesConfirmationContainer">
              <Row>
                <Col xs="12">
                  Voulez-vous vraiment <b>{bloque ? "bloquer" : "débloquer"}</b> le bien <b>{designationValue || ""}</b> ?
                </Col>
              </Row>
              {!!bloque && <Row className="mt-3">
                <Col xs="12">
                  <FormGroup>
                    <Label for="deblockDate">Date du déblocage automatique</Label>
                    <DatePicker id="deblockDate"
                      value={deblockDate}
                      dateFormat={constants.DP_DATE_FORMAT}
                      dayLabels={constants.DP_DAYS}
                      monthLabels={constants.DP_MONTHS}
                      weekStartsOn={constants.DP_WEEK_START}
                      minDate={moment().add(1, 'days').toString()}
                      maxDate={!auth?.user?.privileges?.includes(PRIVILEGE.DEBLOCAGE_BLOCAGE) ? moment().add(6/*=5*/, 'days').toString() : undefined}
                      onChange={(v,f) => deblockDateChangeHandler(v, f)} />
                    {!deblockDate && !!auth?.user?.privileges?.includes(PRIVILEGE.DEBLOCAGE_BLOCAGE) && <Row className="bottomFloatingInputText" style={{marginTop: "3px"}}>
                      {datesSuggestions.map((e, key) => <Col xs="3" className="bottomFloatingInputTextBtns" onClick={() => setDeblockDate(moment().add(Number(e.value || 0) + 1, 'days').toISOString())} key={key}>{e.label}</Col>)}
                    </Row>}
                  </FormGroup>
                </Col>
              </Row>}
              {!!bloque && !!auth?.user?.privileges?.includes(PRIVILEGE.DEBLOCAGE_BLOCAGE) && <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="user">
                      Bloquer pour
                      &nbsp;<FontAwesomeIcon icon={faQuestionCircle} style={{cursor: "pointer", fontSize: "small"}} data-tip data-for="bloqueFortooltip" />
                      <ReactTooltip effect="solid" id="bloqueFortooltip" type={"dark"}>
                        Le commercial choisi va pouvoir débloquer ce bien à tout moment
                      </ReactTooltip>
                    </Label>
                    <Select
                      name="user"
                      className="reactselect"
                      classNamePrefix="react-select"
                      value={userValue ? {label: userValue["username"], value: userValue} : null}
                      onChange={handleUserChange}
                      placeholder={'Chercher par nom...'}
                      isClearable={true}
                      isLoading={loadingU}
                      loadingMessage={() => 'Chargement...'}
                      noOptionsMessage={() => 'pas de resultat'}
                      isSearchable={true}
                      labelKey='name'
                      // valueKey='countryCode'
                      options={userOptions}
                      menuContainerStyle={{ zIndex: 9999999 }}
                    />
                    {!userValue && <Row className="bottomFloatingInputText" style={{marginTop: "3px"}}>
                      {usersSuggestions.filter(e => societeValue && users?.find(t => t.id === e.value)?.societes?.some(t => t.id === societeValue.id)).map((e, key) => <Col xs="3" className="bottomFloatingInputTextBtns" onClick={() => setUserValue(users.find(t => t.id === e.value) || '')} key={key}>{e.label}</Col>)}
                    </Row>}
                  </FormGroup>
                </Col>
              </Row>}
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="comment">Commentaire</Label>
                    <Input id="comment" placeholder="Commentaire..." value={commentValue} onChange={commentChangeHandler} />
                  </FormGroup>
                </Col>
              </Row>
              <Row className="justify-content-center">
                <Button
                  className={`btn btn-${bloque ? "danger" : "warning"} linesConfirmationBtn linesDeleteBtn`}
                  onClick={deOrBloquerHandle}
                  disabled={disableSubmit}
                  ><FontAwesomeIcon icon={disableSubmit ? faSpinner : bloque ? faLock : faLockOpen} className={disableSubmit ? "spinner" : ""} />&nbsp;&nbsp;{bloque ? "Bloquer" : "Débloquer"}</Button>
              </Row>
            </Container>
        </ModalBody>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state: IBienBloquerReduxProps) => ({
  auth: state.auth,
  error: state.error,
  user: state.user,
});

export default connect(mapStateToProps, { deOrBloqueBien, getUsers })(BienBloquer);
